import { lens } from "@dhmk/zustand-lens";

type Mode = "preview" | "code";

type UIState = {
  mode: Mode;
  chatPanelCollapsed: boolean;
  canvasFooterOpen: boolean;
};

type UIActions = {
  setMode: (mode: Mode) => void;
  setChatPanelCollapsed: (collapsed: boolean) => void;
  setCanvasFooterOpen: (open: boolean) => void;
  reset: () => void;
};

export type UISlice = UIState & UIActions;

const defaultUIState = {
  mode: "preview",
  chatPanelCollapsed: false,
  canvasFooterOpen: false,
} satisfies UIState;

export const uiSlice = lens<UISlice>((set) => ({
  ...defaultUIState,
  setMode: (mode) => set({ mode }),
  setChatPanelCollapsed: (collapsed) => set({ chatPanelCollapsed: collapsed }),
  setCanvasFooterOpen: (open) => set({ canvasFooterOpen: open }),
  reset: () => set({ ...defaultUIState }),
}));
